// src/components/Profile/UserSubscriptionDetails.jsx
import React, { useEffect, useState } from "react";
import { fetchUserSubscriptionData } from "../../utilities/UserProfileUtilities";


function SubscriptionDetails() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      setLoading(true);
      try {
        const userData = await fetchUserSubscriptionData();
        if (!alive) return;
        setSubscriptions(userData?.results || []);
      } catch (e) {
        console.error(e);
        if (!alive) return;
        setSubscriptions([]);
      } finally {
        if (alive) setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
  }, []);

  const prettyLabel = (key) =>
    String(key || "")
      .split("_")
      .join(" ")
      .replace(/\s+/g, " ")
      .trim()
      .toUpperCase();

  const displayVal = (v) => {
    if (v == null) return "N/A";
    if (Array.isArray(v)) return v.length ? v.join(", ") : "N/A";
    if (typeof v === "object") return JSON.stringify(v);
    return String(v);
  };

  if (loading) return <div className="ea-empty">Loading subscriptions...</div>;
  if (subscriptions.length === 0) return <div className="ea-empty">No subscriptions found.</div>;

  return (
    <>
      {subscriptions.map((subscription, index) => (
        <section
          key={subscription?.subscription_id || subscription?.id || index}
          className="ea-card"
        >
          <div className="ea-card-head">
            <h2 className="ea-card-title">
              {subscription?.subscription_name ||
                subscription?.plan_name ||
                `Subscription ${index + 1}`}
            </h2>
          </div>

          <div className="ea-card-body ea-grid">
            {Object.entries(subscription || {}).map(([key, value]) => (
              <div key={key} className="ea-field">
                <label>{prettyLabel(key)}</label>
                <div className="ea-value">{displayVal(value)}</div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </>
  );
}

export default SubscriptionDetails;
